export default __webpack_public_path__ + "static/media/NoFile.31d89499.svg";